module.exports = __webpack_public_path__ + "img/w矩形 80@3x.6a63482d.png";